export var LabelVariant;
(function (LabelVariant) {
    LabelVariant["Empty"] = "empty";
    LabelVariant["Segments"] = "segments";
    LabelVariant["AllSegments"] = "all segments";
    LabelVariant["NoneSelected"] = "none selected";
    LabelVariant["SelectSegments"] = "select segments";
    LabelVariant["FilterBySegment"] = "filter by segment";
    LabelVariant["AssignSegment"] = "assign segment";
    LabelVariant["MakeASelection"] = "make a selection";
})(LabelVariant || (LabelVariant = {}));
export var SegmentType;
(function (SegmentType) {
    SegmentType["Basic"] = "BASIC";
    SegmentType["Smart"] = "SMART";
})(SegmentType || (SegmentType = {}));
export var SegmentVisibilityOptions;
(function (SegmentVisibilityOptions) {
    SegmentVisibilityOptions["All"] = "ALL";
    SegmentVisibilityOptions["None"] = "NONE";
    SegmentVisibilityOptions["Some"] = "SOME";
})(SegmentVisibilityOptions || (SegmentVisibilityOptions = {}));
export var SegmentStatus;
(function (SegmentStatus) {
    SegmentStatus["Active"] = "ACTIVE";
    SegmentStatus["Deleted"] = "DELETED";
    SegmentStatus["Archived"] = "ARCHIVED";
})(SegmentStatus || (SegmentStatus = {}));
